import { z } from 'zod';
import { writable } from 'svelte/store';
import { Account } from '../lib/components/Accounts/Account';

export const AppSchema = z.object({
    isAdmin: z.boolean(),
    // account: z.any(), // Account class
    account: z.instanceof(Account).nullable().catch(null),
    commit_hash: z.string().nullable().catch(null),
    session_expires_in_seconds: z.number().nullable(),
});
export type AppType = z.infer<typeof AppSchema>;

export const app = writable<AppType>({
    isAdmin: false,
    account: null,
    commit_hash: null,
    session_expires_in_seconds: null,
});
